/**
 * BaseLayout — racine de l'arbre React Router. Wrap tous les providers
 * (Query, Theme, Toast) + l'`<Outlet />` pour les layouts enfants.
 */

import { Outlet } from 'react-router-dom';
import { QueryProvider, ThemeProvider, ToastProvider, RootErrorBoundary } from '@/app/providers';
import { LegalConsentGate } from '@/features/auth/components/LegalConsentGate';

export function BaseLayout() {
  return (
    <RootErrorBoundary>
      <QueryProvider>
        <ThemeProvider>
          <ToastProvider>
            <Outlet />
            {/* Gate RGPD global : modale bloquante si l'user a des documents
                légaux en attente d'acceptation (cf. SAAS-473 / KB SAAS-A-131). */}
            <LegalConsentGate />
          </ToastProvider>
        </ThemeProvider>
      </QueryProvider>
    </RootErrorBoundary>
  );
}
